import i18n from '@/i18n'

export const t = (...args) => i18n.t(...args)
